<template>
  <div class="head-count-swiper__container wd-relative">
    <div class="wd-py-4">
      <div class="sheet-title d-flex justify-space-between align-center">
        <span class="wd-text-olg wd-font-medium md:wd-font-normal">{{ $t('select_pax') }}</span>

        <v-btn v-if="!hideGroup" class="group-hint__btn pa-0" color="orange50" variant="text" @click="openHowToOrderDialog">
          {{ $t('how_to_group') }}
        </v-btn>
      </div>
      <slot name="summary" />
    </div>

    <v-slide-group v-model="slideHeadCount" class="head-count__slide" show-arrows mandatory>
      <template #prev>
        <v-btn class="arrow-btn" min-width="32" width="32" height="32" variant="text">
          <funnow-icon max-width="20" :image-path="'chevron-left.svg'" />
        </v-btn>
      </template>
      <template #next>
        <v-btn class="arrow-btn" min-width="32" width="32" height="32" variant="text">
          <funnow-icon max-width="20" :image-path="'chevron-right.svg'" />
        </v-btn>
      </template>
      <v-slide-group-item v-for="(count, idx) in headCountItems" :key="idx" v-slot="{ isSelected, toggle }" :value="count.value">
        <v-btn
          :active="isSelected"
          class="mr-3 !wd-min-w-0"
          :class="{ '!wd-bg-orange50 !wd-text-white': isSelected }"
          :width="32"
          :height="32"
          variant="text"
          rounded
          @click="toggle"
        >
          {{ count.value }}
        </v-btn>
      </v-slide-group-item>
    </v-slide-group>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

defineOptions({
  name: 'HeadCountPicker',
})

interface Props {
  modelValue: number | null
  headCountItems: Array<any>
  hideGroup: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: 1,
  headCountItems: () => [],
  hideGroup: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: number | null]
}>()

const slideHeadCount = useVModel(props, 'modelValue', emit)

const { $store } = useNuxtApp()
const i18n = useI18n()

function openHowToOrderDialog() {
  const options = {
    header: i18n.t('how_to_group'),
    message: i18n.t('how_to_group_content'),
    useCloseIcon: true,
  }
  $store.dispatch('dialog/setRootMessageOption', { status: true, options: options })
}
</script>

<style scoped lang="scss">
.head-count-swiper__container {
  min-height: 66px;
  .sheet-title {
    width: 100%;

    .group-hint__btn {
      font-size: 13px;
    }
  }

  .count__btn {
    font-size: 15px !important;

    &:before {
      background-color: unset;
    }
  }
}
</style>
<style lang="scss">
.head-count__slide {
  .v-slide-group {
    &__next,
    &__prev {
      min-width: 32px;
      position: absolute;
      z-index: 2;

      &--disabled {
        display: none;
      }
    }
    &__prev {
      left: -12px;
      background: linear-gradient(to right, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);
    }

    &__next {
      right: -12px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%);
    }
  }
}
</style>
